export class DocumentChanges {
  public action = "";
  public user = "";
  public dateTime ="";
}
